<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="6" class="pa-0 pr-1">
        <v-select
          v-validate="required.responsible_team"
          :value="form.responsible_team"
          :items="responsibleTeams"
          :label="mess['dialog_request_responsible_team']"
          :error-messages="errors.collect('responsible_team')"
          item-text="name"
          item-value="name"
          outlined
          dense
          data-vv-name="responsible_team"
          @change="$emit('update:form', { key: 'responsible_team', value: $event })"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pl-1">
        <v-select
          v-validate="required.priority"
          :value="form.priority"
          :items="priorities"
          :label="mess['dialog_request_priority']"
          :error-messages="errors.collect('priority')"
          outlined
          dense
          data-vv-name="priority"
          @change="$emit('update:form', { key: 'priority', value: $event })"
        />
      </v-col>
    </v-row>

    <v-row v-if="showWorkTypes">
      <v-col cols="12" class="pa-0">
        <v-select
          v-validate="required.work_type"
          :value="form.work_type"
          :items="workTypes"
          :label="mess['dialog_request_work_type']"
          :error-messages="errors.collect('work_type')"
          outlined
          dense
          data-vv-name="work_type"
          @change="$emit('update:form', { key: 'work_type', value: $event })"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-text-field
          :value="getDeadline"
          :label="mess['dialog_request_deadline']"
          :disabled="true"
          outlined
          dense
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-select
          v-validate="required.reason_of_request"
          :value="form.reason_of_request"
          :items="requestReasons"
          :label="mess['dialog_request_reason_of_request']"
          :error-messages="errors.collect('reason_of_request')"
          outlined
          dense
          data-vv-name="reason_of_request"
          @change="$emit('update:form', { key: 'reason_of_request', value: $event })"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import RequestForm from "@/mixins/RequestForm";

export default {
  name: "EMCUserForm",
  mixins: [RequestForm],
  inject: ["$validator"],
  props: {
    form: {
      type: [Object, null],
      required: true
    }
  },
  computed: {
    deadlines() {
      return window.initialData?.deadlines || [];
    },
    getDeadline() {
      if (!(Object.hasOwn(this.form, 'responsible_team') && Object.hasOwn(this.form, 'priority'))) return "";

      const team = this.deadlines.find(item => item.team.toLowerCase() === this.form.responsible_team.toLowerCase());
      const priority = team.priority.find(item => item.priority.toLowerCase() === this.form.priority.toLowerCase());

      this.$emit('update:form', { key: 'deadline', value: priority.deadline })

      return priority.deadline;
    },
    errors() {
      return {};
    },
    priorities() {
      return window.initialData?.priorities || [];
    },
    requestReasons () {
      return window.initialData?.requestReasons || [];
    },
    responsibleTeams() {
      return window.initialData?.responsibleTeams || [];
    },
    showWorkTypes() {
      if (!Object.hasOwn(this.form, 'responsible_team')) return false;

      const responsible_team = this.responsibleTeams.find(item => item.name === this.form.responsible_team);

      return responsible_team.isThereWorkType;
    },
    workTypes() {
      return window.initialData?.workTypes || [];
    }
  }
};
</script>
